import React, { useState } from 'react';
import FaiBox from "../../../../MuiComponents/FaiBox";
import {Stack} from "@mui/material";
import FaiButton from "../../../../MuiComponents/FaiButton";
import Icon from "@mui/material/Icon";
import Strip from "../../../../components/Strip";
import FaiInput from "../../../../MuiComponents/FaiInput";
import { useNavigate } from 'react-router-dom';

interface HeaderBarProps {
    onFilterChange?: (filters: { couponCode?: string; campaignName?: string }) => void;
}

function HeaderBar({ onFilterChange }: HeaderBarProps) {
    const navigate = useNavigate();
    const [inputValues, setInputValues] = useState<{ couponCode: string; campaignName: string }>({
        couponCode: '',
        campaignName: ''
    });
    
    const handleInputChange = (field: string, value: string) => {
        setInputValues(prev => ({ ...prev, [field]: value }));
    };

    const handleFilterClick = () => {
        console.log('Filter clicked with values:', inputValues);
        const newFilters: { couponCode?: string; campaignName?: string } = {};
        
        if (inputValues.couponCode.trim()) {
            newFilters.couponCode = inputValues.couponCode.trim();
        }
        if (inputValues.campaignName.trim()) {
            newFilters.campaignName = inputValues.campaignName.trim();
        }
        
        console.log('Applying filters:', newFilters);
        onFilterChange?.(newFilters);
    };

    const handleResetClick = () => {
        console.log('Reset clicked');
        setInputValues({ couponCode: '', campaignName: '' });
        onFilterChange?.({});
    };

    return (
        <>
            <FaiBox mb={3}>
                <Strip>
                    <FaiBox>
                        <FaiBox display={"flex"} alignItems={"center"} justifyContent="space-between">
                            <div></div>
                            <FaiBox m={"10px 10px"}>
                                <Stack direction="row" spacing={2}>
                                    {/* <FaiButton sx={{
                                        padding: "7px 12px !important",
                                        height: "34px",
                                        minHeight: 0
                                    }} variant="contained" color="error">
                                        <Icon sx={{ marginRight: "5px" }}>
                                            delete_outline_outlined
                                        </Icon> Delete
                                    </FaiButton> */}
                                    <FaiButton 
                                        sx={{
                                            padding: "7px 12px !important",
                                            height: "34px",
                                            minHeight: 0
                                        }} 
                                        variant="contained" 
                                        color="success"
                                        onClick={() => navigate('/app/promotions/add-promotion')}
                                    >
                                        <Icon sx={{ marginRight: "5px" }}>
                                            add
                                        </Icon> Add Coupon
                                    </FaiButton>
                                </Stack>
                            </FaiBox>
                        </FaiBox>
                    </FaiBox>
                </Strip>
            </FaiBox>
            
            <Strip>
                <FaiBox p={"10px 10px"}>
                    <FaiBox display={"flex"} alignItems={"center"} justifyContent="space-between">
                        <FaiBox>
                            <Stack spacing={1} direction="row">
                                <FaiInput
                                    placeholder="Search by Coupon Code"
                                    value={inputValues.couponCode}
                                    onChange={(e) => handleInputChange('couponCode', e.target.value)}
                                    sx={{ width: '200px' }}
                                />
                                <FaiInput
                                    placeholder="Search by Campaign Name"
                                    value={inputValues.campaignName}
                                    onChange={(e) => handleInputChange('campaignName', e.target.value)}
                                    sx={{ width: '200px' }}
                                />
                            </Stack>
                        </FaiBox>
                        <Stack direction="row" spacing={1}>
                            <FaiButton 
                                sx={{
                                    padding: "7px 12px !important",
                                    height: "34px",
                                    minHeight: 0
                                }} 
                                variant="contained" 
                                color="primary"
                                onClick={handleFilterClick}
                            >
                                Filter
                            </FaiButton>
                            <FaiButton 
                                sx={{
                                    padding: "7px 12px !important",
                                    height: "34px",
                                    minHeight: 0
                                }} 
                                variant="contained" 
                                color="dark"
                                onClick={handleResetClick}
                            >
                                Reset
                            </FaiButton>
                        </Stack>
                    </FaiBox>
                </FaiBox>
            </Strip>
        </>
    );
}

export default HeaderBar;
